import { render, staticRenderFns } from "./supplier-tier-line.vue?vue&type=template&id=4b0e2ac6&scoped=true"
import script from "./supplier-tier-line.vue?vue&type=script&lang=js"
export * from "./supplier-tier-line.vue?vue&type=script&lang=js"
import style0 from "./supplier-tier-line.vue?vue&type=style&index=0&id=4b0e2ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e2ac6",
  null
  
)

export default component.exports